import { useEffect, useState } from 'react';
import {
  PossibleCompetitorContract,
  getPossibleCompetitorContracts,
  peekPossibleCompetitorContracts,
} from 'services/actions/ai_management_possible_competitors';

export function usePossibleCompetitorContracts(
  biddingId: number | null,
  historicBiddingId: number,
  cnpj: string,
) {
  const peek = () =>
    biddingId ? peekPossibleCompetitorContracts(biddingId, historicBiddingId, cnpj) : undefined;
  const [contracts, setContracts] = useState<PossibleCompetitorContract[]>(
    () => peek()?.data.contratos ?? [],
  );
  const [loading, setLoading] = useState(() => !peek());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!biddingId) {
      setLoading(false);
      setError(true);
      return undefined;
    }

    const hit = peek();
    if (hit) {
      setContracts(hit.data.contratos ?? []);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError(false);

    getPossibleCompetitorContracts(biddingId, historicBiddingId, cnpj)
      .then(({ data }) => {
        if (!active) return;
        setContracts(data.contratos ?? []);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [biddingId, historicBiddingId, cnpj]);

  return { contracts, loading, error };
}
